<nz-page-header class="site-page-header">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <a routerLink="../..">
        <i nz-icon nzType="home"></i>
      </a>
    </nz-breadcrumb-item>

    <nz-breadcrumb-item>
      <a routerLink="..">
        <i nz-icon nzType="appstore"></i>
        Funcionalidades
      </a>
    </nz-breadcrumb-item>

    <nz-breadcrumb-item>
      <i nz-icon nzType="warning"></i>
      Avisos do sistema
    </nz-breadcrumb-item>
  </nz-breadcrumb>

  <nz-page-header-title>
    <div class="title">Avisos do sistema</div>

    <p nz-typography nzType="secondary" class="subtitle">Todo aviso que estiver ativo aparecerá para todos usuários</p>
  </nz-page-header-title>

  <nz-page-header-extra>
    <button nz-button nzType="default" (click)="getData()" [disabled]="status === 'LOADING'">
      <i nz-icon nzType="reload" [nzSpin]="status === 'LOADING'"></i>
    </button>

    <button nz-button nzType="primary" routerLink="/home/features/system-broadcasts/create">
      <i nz-icon nzType="plus"></i>
      Criar aviso
    </button>
  </nz-page-header-extra>
</nz-page-header>

<div class="px-4">
  <nz-card class="p-4" *ngIf="status === 'LOADING'">
    <nz-spin nzTip="Carregando avisos..."></nz-spin>
  </nz-card>

  <nz-card class="p-4" *ngIf="status === 'ERROR'">
    <div style="text-align: center">
      <h2 nz-typography nzType="danger">Erro ao carregar avisos</h2>
      <h4 nz-typography>Ocorreu um erro ao carregar os avisos. Tente novamente, por favor.</h4>
      <button nz-button nzType="primary" (click)="getData()">Tentar novamente</button>
    </div>
  </nz-card>

  <nz-table #systemBroadcastsTable [nzData]="systemBroadcastsData" [nzFrontPagination]="false" *ngIf="status === 'SUCCESS'">
    <thead>
      <tr>
        <th>Título</th>
        <th>White label</th>
        <th>Tipo(s) de usuário(s)</th>
        <th>Tipo(s) de condomínio(s)</th>
        <th>Canal do aviso</th>
        <th>Criado em</th>
        <th>Período de exibição</th>
        <th>Ativo?</th>
        <th>Visualizações</th>
        <th>Ações</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let data of systemBroadcastsTable.nzData">
        <td>
          <div class="broadcast-title">{{ data.title }}</div>
        </td>
        <td>{{ data.whiteLabels }}</td>
        <td>{{ data.userTypes }}</td>
        <td>{{ data.condoTypes }}</td>
        <td>{{ notificationChannelLabelMap[data.notificationChannel] }}</td>
        <td>
          <nz-tag>
            {{ data.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}
          </nz-tag>
        </td>
        <td>
          a partir de {{ data.startDate | date: 'dd/MM/yyyy' }}
          <ng-container *ngIf="data.endDate">até {{ data.endDate | date: 'dd/MM/yyyy' }}</ng-container>
        </td>
        <td>
          <nz-tag
            style="cursor: pointer"
            [nzColor]="data.isActive ? 'green' : 'red'"
            nz-popconfirm
            nzPopconfirmTitle="Deseja realmente {{ data.isActive ? 'desativar' : 'ativar' }} este aviso?"
            (nzOnConfirm)="handleToggle(data)">
            {{ data.isActive ? 'Sim' : 'Não' }}
          </nz-tag>
        </td>

        <td>{{ data.linkButtonClickCount }}</td>
        <td>
          <button nz-button nzType="primary" nz-dropdown [nzDropdownMenu]="menu" [nzClickHide]="false">
            Ações
            <i nz-icon nzType="down"></i>
          </button>

          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li
                nz-menu-item
                nz-popconfirm
                nzPopconfirmTitle="Deseja realmente {{ data.isActive ? 'desativar' : 'ativar' }} este aviso?"
                (nzOnConfirm)="handleToggle(data)">
                <span>
                  <i nz-icon nzType="poweroff"></i>
                  {{ data.isActive ? 'Desativar' : 'Ativar' }}
                </span>
              </li>

              <li nz-menu-item *ngIf="!data.isActive">
                <a [routerLink]="[data._id, 'edit']">
                  <i nz-icon nzType="edit"></i>
                  Editar
                </a>
              </li>

              <li nz-menu-item nz-popconfirm nzPopconfirmTitle="Deseja realmente excluir este aviso?" (nzOnConfirm)="handleDelete(data)">
                <span nz-typography nzType="danger">
                  <i nz-icon nzType="delete"></i>
                  Excluir
                </span>
              </li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <nz-pagination
    nz-row
    nzJustify="end"
    nzShowSizeChanger
    [nzTotal]="totalData"
    [nzPageIndex]="0"
    [nzPageSize]="nzPageSize"
    [nzPageSizeOptions]="[50, 100, 250, 500]"
    (nzPageIndexChange)="refreshIndexChange($event)"
    (nzPageSizeChange)="refreshSizeChange($event)"></nz-pagination>
</div>
